import {
  Box,
  FormHelperText as MuiFormHelperText,
  InputAdornment,
  InputLabel as MuiInputLabel,
  OutlinedInput
} from '@mui/material';
import { EventOutlined } from '@mui/icons-material';
import { ChangeEvent, CSSProperties, forwardRef } from 'react';
import MaskedInput from 'react-text-mask';

import { MASK } from '../../../../constants/mask';
import { convertToKebabCase } from '../../../../constants/helpers/text';

interface TextMaskCustomProps {
  inputRef: (ref: HTMLInputElement | null) => void;
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const TextMaskCustom = forwardRef((props: TextMaskCustomProps, ref) => {
  const { ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef => {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ref = inputRef;
      }}
      mask={MASK.DATE}
      showMask={false}
    />
  );
});

interface Props {
  name: string;
  value: string | null;
  placeholder: string;
  label: string;
  handleChange: (value: string) => void;
  handleBlur: (e: ChangeEvent) => void;
  handleRangePickerOpen: () => void;
  style?: CSSProperties;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
}

const DateInput = ({
  name,
  value,
  placeholder,
  label,
  handleChange,
  handleBlur,
  handleRangePickerOpen,
  style,
  error,
  touched,
  disabled,
  ...props
}: Props) => {
  const hasError = Boolean(error && touched);
  return (
    <Box style={style} width="100%" {...props}>
      <MuiInputLabel id={`${label}-label`}>{label}</MuiInputLabel>
      <OutlinedInput
        name={name}
        style={{ height: '48px' }}
        data-testid={`input-${convertToKebabCase(label)}`}
        disabled={disabled}
        fullWidth
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onChange={e => {
          handleChange(e.target.value);
        }}
        onBlur={handleBlur}
        type="date-time"
        value={value}
        placeholder={placeholder}
        inputComponent={TextMaskCustom}
        endAdornment={
          <InputAdornment disablePointerEvents={disabled} position="end">
            <EventOutlined
              data-testid="date-picker-icon"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                handleRangePickerOpen();
              }}
              cursor="pointer"
              color="inherit"
              fontSize="small"
            />
          </InputAdornment>
        }
      />
      {hasError && (
        <MuiFormHelperText error={hasError} id="error">
          {error}
        </MuiFormHelperText>
      )}
    </Box>
  );
};

export default DateInput;
